module.exports = __webpack_public_path__ + "media/images/covid/icons/cashlessS-10b9fd4c028efa8bfc74d92808bb0936.png";